(function autoCloseDetails() {
  // PERF: this runs on EVERY click anywhere in the document. The original did a
  // full querySelectorAll + spread + filter each time. We now short-circuit with a
  // single querySelector, which stops at the first match and returns null cheaply
  // when nothing is open - the overwhelmingly common case.
  document.addEventListener('click', function (event) {
    if (!document.querySelector('details[data-auto-close-details][open]')) return;

    var closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
    var openDetails = document.querySelectorAll('details[data-auto-close-details][open]');

    for (var i = 0; i < openDetails.length; i++) {
      var element = openDetails[i];
      var attr = element.getAttribute('data-auto-close-details');
      if (!attr || attr.indexOf(closingOn) === -1) continue;
      if (event.target instanceof Node && element.contains(event.target)) continue;
      element.removeAttribute('open');
    }
  });
})();
